import React, { useEffect, useState } from 'react'
import { MultiSelectFromListModal } from '../../../../molecules/MultiSelectFromListModal'
import helpers from 'core/helpers'
import styles from './styles.jcss'
import translate from 'core/translate'
import Button from 'blocks.simple/button/button'
import { api } from '../../../../core/api/ConnectionManager'
import { authorsListToShort } from '../../../../blocks.app/catalog/__template/_catalogizator/arts/catalog__template_arts.local.methods'
import { FileDetails } from '../FileDetails'
import {
    AuthorListItem,
    AuthorShortItem,
    AuthorsListType,
    AuthorToSourceLink,
    SourceListItem,
    SourcesToAuthorsFakeLineMedia,
    SourcesToAuthorsFromListModalProps,
} from './SourcesToAuthorsFromListModal-types'

type MultiSelectFromListModalProps = {
    initList?: AuthorShortItem[]
    selectedList?: AuthorShortItem[]
    header?: () => React.ReactNode
    openStatus?: boolean
    onSelect?: (selectedItems: number[]) => void
    onCancel?: () => void
}

const TypedMultiSelectFromListModal = MultiSelectFromListModal as React.ComponentType<MultiSelectFromListModalProps>

export const SourcesToAuthorsFromListModal = ({
    onSelect,
    placeholder,
    callbackList,
    sourceList,
    authorsInProject,
    authorsToSource,
    fakeLine,
    authorsList,
}: SourcesToAuthorsFromListModalProps) => {
    const [isOpen, setIsOpen] = useState(false)
    const [choiceAuthors, setChoiceAuthors] = useState(false)
    const [selectedSourceId, setSelectedSourceId] = useState<number | null>(null)
    const [authors, setAuthors] = useState<AuthorShortItem[]>(authorsInProject ? authorsInProject : [])
    const [itemsList, setItemsList] = useState<SourceListItem[]>(sourceList ? sourceList : [])
    const [authorsToSourceList, setAuthorsToSourceList] = useState<AuthorToSourceLink[]>(
        authorsToSource ? authorsToSource : []
    )

    useEffect(() => {
        if (!authorsList) return

        setAuthors(authorsListToShort(authorsList))
    }, [authorsList])

    const onClose = () => {
        setSelectedSourceId(null)
        setChoiceAuthors(false)
    }

    const setSourceLinks = (selectedItems: number[]) => {
        const sortedSources = authorsToSourceList.filter((source) => source.sourceId !== selectedSourceId)

        setAuthorsToSourceList([
            ...sortedSources,
            ...selectedItems.map((id) => {
                return {
                    authorId: id,
                    sourceId: selectedSourceId,
                }
            }),
        ])
    }

    const linkIsExist = (author: AuthorShortItem, links: AuthorToSourceLink[], sourceId: number | null) => {
        for (let j = 0; j < links.length; j++) {
            const authorToSourceItem = links[j]

            if (authorToSourceItem.sourceId === sourceId) {
                if (authorToSourceItem.authorId === author.id) {
                    return true
                }
            }
        }

        return false
    }

    const getAuthorsList = (type: AuthorsListType) => {
        const list: AuthorShortItem[] = []

        for (let i = 0; i < authors.length; i++) {
            const author = authors[i]

            if (type === 'selected') {
                if (linkIsExist(author, authorsToSourceList, selectedSourceId)) {
                    list.push(author)
                }
            }
            if (type === 'init') {
                list.push(author)
            }
        }

        return list
    }

    const authorToSourceCheck = (list: AuthorToSourceLink[], id: number) => {
        const linkedSourceList: number[] = []

        list.forEach((listItem) => {
            if (listItem.sourceId === id) {
                linkedSourceList.push(listItem.authorId)
            }
        })

        return linkedSourceList.length ? (
            <span className={styles.linkedAuthors}>привязано авторов: {linkedSourceList.length}</span>
        ) : null
    }

    const renderHeader = () => {
        return <FileDetails sourceId={selectedSourceId} />
    }

    const renderSelectMenu = () => {
        return (
            <TypedMultiSelectFromListModal
                initList={getAuthorsList('init')}
                selectedList={getAuthorsList('selected')}
                header={renderHeader}
                openStatus={choiceAuthors}
                onSelect={(selectedItems: number[]) => {
                    setSourceLinks(selectedItems)

                    onClose()
                }}
                onCancel={onClose}
            />
        )
    }

    useEffect(() => {
        if (fakeLine) {
            const fakeLineMedia = fakeLine.media as SourcesToAuthorsFakeLineMedia | undefined

            if (fakeLineMedia?.id) {
                const item = fakeLineMedia.id

                api.send('getSources', {
                    folderId: item.isDirectory ? fakeLineMedia.id?.id : fakeLineMedia.id?.folderId,
                }).then((res) => {
                    const sources = res as SourceListItem[]
                    setItemsList(!item.isDirectory ? sources.filter((media) => media.id === item.id) : sources)
                })
            }

            if (fakeLine.authors) {
                api.send('getAuthorsNames', { limit: 10000 }).then((res) => {
                    const authorsShortList = callbackList(res as AuthorListItem[])
                    const selectedAuthorsIds = fakeLine.authors
                    const sortedAuthors = authorsShortList.filter((author) => selectedAuthorsIds?.includes(author.id))

                    setAuthors(sortedAuthors)
                })
            }
        }
    }, [fakeLine])

    useEffect(() => {
        if (isOpen) {
            helpers.disableWindowScroll(true, 'SourcesToAuthorsFromListModal')
        } else {
            helpers.disableWindowScroll(false, 'SourcesToAuthorsFromListModal')
        }
    }, [isOpen])

    useEffect(() => {
        if (selectedSourceId) {
            setChoiceAuthors(true)
        }
    }, [selectedSourceId])

    return (
        <>
            {isOpen ? (
                <div className={styles.modalBackLayer}>
                    <div className={styles.modal}>
                        <div className={styles.modalContent}>
                            <ul className={styles.modalListWrapper}>
                                {itemsList
                                    ? itemsList.map((item) => {
                                          return (
                                              <li
                                                  key={item.id}
                                                  className={`
                                                    ${styles.modalListElement} 
                                                    ${item.selected ? styles.elementActive : null}
                                                `}
                                                  onClick={() => {
                                                      setSelectedSourceId(item.id)
                                                  }}
                                              >
                                                  {item.name.replace(/\.[^/.]+$/, '')}
                                                  {authorToSourceCheck(authorsToSourceList, item.id)}
                                              </li>
                                          )
                                      })
                                    : null}
                            </ul>
                        </div>
                        <div className={styles.nav}>
                            <Button
                                mod={'fill'}
                                indentSize={'mini'}
                                textSize={'mini'}
                                rounded={'full_normal'}
                                onClick={function () {
                                    setIsOpen(false)
                                }}
                            >
                                {translate('cancel')}
                            </Button>
                            <Button
                                mod={'fill'}
                                indentSize={'mini'}
                                textSize={'mini'}
                                rounded={'full_normal'}
                                onClick={function () {
                                    onSelect(authorsToSourceList.filter((item) => item.authorId))
                                    setIsOpen(false)
                                }}
                            >
                                {translate('save')}
                            </Button>
                        </div>
                    </div>
                </div>
            ) : (
                <div onClick={() => setIsOpen(true)}>
                    {authorsToSourceList.length
                        ? `${translate('linked')} (${authorsToSourceList.filter((item) => item.authorId).length})`
                        : placeholder}
                </div>
            )}
            {choiceAuthors ? renderSelectMenu() : null}
        </>
    )
}
